<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sharpen`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.637 45a3 3 0 01-2.67-4.369L21.331 4.823a3 3 0 015.338 0L45.034 40.63A3 3 0 0142.363 45H5.637zM22 12.283L7.273 41H22V12.283zM26 41V12.283L40.727 41H26z"/></svg>
</template>
<script>

export default {
  name: 'IconSharpen',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
